export default __webpack_public_path__ + "static/media/DJI_0940.MP4.00_01_42_18.Still006.9f9fb69e.jpg";